// removed by extract-text-webpack-plugin
module.exports = {"height":"32px","container":"container-2YFTy","button":"button-WoJdd","icon":"icon-3E_2x","input":"input-3KewD","form":"form-1BmTK","formDisabled":"formDisabled-1o6t7 form-1BmTK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/header/_searchForm.css
// module id = 1234
// module chunks = 1